import '../../../App.css';
import './BetsList.css';
import { useState, useEffect } from 'react';
import { Input, Table, Select, Pagination } from 'antd';
import moment from 'moment';
import axios from 'axios';
import Appconfig from '../../../config/config'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import { format } from 'date-fns';
import 'react-calendar/dist/Calendar.css';
import 'react-datepicker/dist/react-datepicker.css';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';


function BetsList({ user_id }) {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))

    // Default: from_date = 7 days ago at 11:59, to_date = today at 11:59
    const defaultFrom = moment().subtract(7, 'days').set({ hour: 11, minute: 59 }).toDate();
    const defaultTo = moment().set({ hour: 11, minute: 59 }).toDate();

    const [formData, setFormData] = useState({
        "user_id": user_id ? user_id : userInfo._id,
        "type": "0",
        "from_date": defaultFrom,
        "to_date": defaultTo,
        "game_type": "All",
    });

    const options = {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true // Enables 12-hour clock with AM/PM
    };

    // ***************  Calendar Start ****************

    const [showFromCalendar, setShowFromCalendar] = useState(false);

    const handleFromDate = (newDate) => {

        if (newDate) {
            setFormData({
                ...formData,
                from_date: newDate
            })
            setShowFromCalendar(false);
        }
        // Hide the calendar after selecting a date
    };

    const toggleFromCalendar = () => {
        setShowFromCalendar(!showFromCalendar);
        setShowToCalendar(false);
    };

    const [showToCalendar, setShowToCalendar] = useState(false);

    const handleToDate = (newDate) => {
        if (newDate) {
            setFormData({
                ...formData,
                to_date: newDate
            })
            //   setToDate(newDate);
            setShowToCalendar(false); // Hide the calendar after selecting a date
        }

    };

    const toggleToCalendar = () => {
        setShowToCalendar(!showToCalendar);
        setShowFromCalendar(false);
    };
    const formattedFromDate = formData.from_date ? format(formData.from_date, 'dd-MM-yyyy') : format(new Date, 'dd-MM-yyyy');
    const formattedToDate = formData.to_date ? format(formData.to_date, 'dd-MM-yyyy') : format(new Date, 'dd-MM-yyyy');

    // ***************  Calendar End ****************


    const onChangeBetStatus = (betstatus) => {

        setFormData({
            ...formData,
            "status": betstatus
        })
    }
    const onChangeSportType = (sporttype) => {
        setFormData({
            ...formData,
            "event_type": sporttype
        })
    }

    let locale = {
        emptyText: 'No data!',
    };
    const columns = [

        {
            title: 'Sport Name',
            dataIndex: 'name',
            sorter: true,
            width: '35%',
            render: (_, record) => (
                record.event_type == 4 ?
                    (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Cricket
                        </span>
                    ) : record.event_type == 2 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Tennis
                        </span>
                    ) : record.event_type == 1 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Soccer
                        </span>
                    ) : record.event_type == 777 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            WCO Casino
                        </span>
                    ) : record.event_type == 7 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Horse Racing
                        </span>
                    ) : record.event_type == 66102 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Casino
                        </span>
                    ) : record.event_type == 4339 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Greyhound Racing
                        </span>
                    ) : record.event_type == 27979456 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Kabaddi
                        </span>
                    ) : record.event_type == 7522 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Basketball
                        </span>
                    ) : record.event_type == 2378961 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Politics
                        </span>
                    ) : record.event_type == 66101 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Virtual
                        </span>
                    ) : record.event_type == 66104 ? (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Lottery
                        </span>
                    ) : (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                            Other
                        </span>
                    )
            ),
        },
        {
            title: 'Event Name',
            dataIndex: 'name',
            sorter: true,
            width: '50%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {record?.event_type == 777 ? record?.remarks.split('(')[0].trim() : record?.event_name}
                </span>
            )
        },
        {
            title: 'Market name',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {record?.event_type == "777" ? record?.game_code : record?.market_name}
                </span>
            )
        },
        {
            title: 'Selection',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                    {record?.event_type == "777" ? '-' : record?.runner_name}
                </span>
            )
        },
        {
            title: 'Type',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{
                    record.event_type == "777" ? (
                        <div className=''>
                            {record?.transaction_type}
                        </div>
                    ) :
                        record.is_back == 0 ?
                            (
                                <span className='font-extrabold text-[#d50000] text-[0.813rem] '>
                                    Lay
                                </span>
                            ) :
                            (
                                <span className='font-extrabold text-[#09437f] text-[0.813rem] '>
                                    Back
                                </span>
                            )
                }
                </span>
            )
        },
        {
            title: 'Odds Req.',
            dataIndex: 'name',
            sorter: false,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record.event_type == 777 ? '-' : Number(record.price_val).toFixed(2)}</span>
            )
        },
        {
            title: 'Stack',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] '>{record.event_type == 777 ? record?.amount : Number(record.stake).toFixed(2)}</span>
            )
        },
        {
            title: 'Place Time',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => {
                // Extract the date part before 'T'
                const date = new Date(record.createdAt);
                const formattedDate = date.toLocaleString('en-US', options);

                return (
                    <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                        {formattedDate}
                    </span>
                );
            }
        },
        {
            title: 'Settle Time',
            dataIndex: 'name',
            sorter: true,
            width: '25%',
            render: (_, record) => {
                // Extract the date part before 'T'
                const date = new Date(record.updatedAt);
                const formattedDate = date.toLocaleString('en-US', options);
                return (
                    <span className='font-extrabold text-[#212529] text-[0.813rem] '>
                        {formattedDate}
                    </span>
                );
            }
        },
    ];

    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([]);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1); // Reset to the first page after changing page size
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));

    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = filteredData?.length > 0 && filteredData.slice(startIndex, endIndex);


    useEffect(() => {
        filterBetHistory();
    }, [])

    const filterBetHistory = async (e) => {

        var data = JSON.stringify(formData);

        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/aurafilterbetHistory`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                try {
                    console.log(response.data.resultData);
                    setFilteredData(response.data.resultData);

                } catch (e) {
                    // postErrorToslack(e.message);
                }
            })
            .catch(function (error) {
                console.log(error);
                // postErrorToslack(error.message);
            });
    }

    const onChangeDataType = (datatype) => {
        if (datatype == "LIVE") {
            setFormData({
                ...formData,
                from_date: moment().format('YYYY-MM-DD')
            })
        } else if (datatype == "BACKUP") {
            setFormData({
                ...formData,
                from_date: moment().subtract(3, 'month').format('YYYY-MM-DD')
            })
        } else if (datatype == "OLD") {
            setFormData({
                ...formData,
                from_date: moment().subtract(1, 'year').format('YYYY-MM-DD')
            })
        }

    }



    return (
        <div className="bets-list-page">

            {/* Filter Section */}
            <section className="bets-filter-card">
                <div className="bets-filter-grid">

                    <div className="bets-filter-field">
                        <label htmlFor="typeSelect">Type</label>

                        <select
                            id="typeSelect"
                            className="bets-filter-select"
                            defaultValue="Settled"
                            onChange={(e) =>
                                onChangeBetStatus(e.target.value)
                            }
                        >
                            <option value="Settled">Settle</option>
                            <option value="Open">UnSettle</option>
                            <option value="void">Void</option>
                        </select>
                    </div>

                    <div className="bets-filter-field">
                        <label htmlFor="sport">Sport</label>

                        <select
                            id="sport"
                            className="bets-filter-select"
                            defaultValue="ALL"
                            onChange={(e) =>
                                onChangeSportType(e.target.value)
                            }
                        >
                            <option value="ALL">ALL</option>
                            <option value="4">Cricket</option>
                            <option value="2">Tennis</option>
                            <option value="1">Soccer</option>
                            <option value="777">Casino</option>
                        </select>
                    </div>

                    <div className="bets-filter-field">
                        <label>From</label>

                        <DatePicker
                            showTime={{ format: "HH:mm" }}
                            format="DD-MM-YYYY HH:mm"
                            value={dayjs(formData.from_date)}
                            className="bets-date-picker"
                            onChange={(date, dateString) =>
                                setFormData({
                                    ...formData,
                                    from_date: dayjs(
                                        dateString,
                                        "DD-MM-YYYY HH:mm"
                                    ).toDate(),
                                })
                            }
                        />
                    </div>

                    <div className="bets-filter-field">
                        <label>To</label>

                        <DatePicker
                            showTime={{ format: "HH:mm" }}
                            format="DD-MM-YYYY HH:mm"
                            value={dayjs(formData.to_date)}
                            className="bets-date-picker"
                            onChange={(date, dateString) =>
                                setFormData({
                                    ...formData,
                                    to_date: dayjs(
                                        dateString,
                                        "DD-MM-YYYY HH:mm"
                                    ).toDate(),
                                })
                            }
                        />
                    </div>

                    <div className="bets-filter-action">
                        <Button
                            type="primary"
                            onClick={filterBetHistory}
                            className="bets-history-button"
                        >
                            Get History
                        </Button>
                    </div>

                </div>
            </section>

            {/* Bet History Section */}
            <section className="bets-history-card">

                <div className="bets-history-header">
                    <span>Bet History</span>
                </div>

                <div className="bets-history-body">

                    <Table
                        title={() => (
                            <div className="bets-table-toolbar">

                                <div className="bets-page-size">
                                    <label>
                                        <span>Show</span>

                                        <Select
                                            defaultValue={10}
                                            onChange={handlePageSizeChange}
                                            className="pagesize-select"
                                        >
                                            <Select.Option value={10}>
                                                10
                                            </Select.Option>

                                            <Select.Option value={25}>
                                                25
                                            </Select.Option>

                                            <Select.Option value={50}>
                                                50
                                            </Select.Option>

                                            <Select.Option value={100}>
                                                100
                                            </Select.Option>
                                        </Select>

                                        <span>entries</span>
                                    </label>
                                </div>

                                <div className="bets-search">
                                    <label>
                                        <span>Search:</span>

                                        <Input
                                            className="bets-search-input"
                                        // onChange={(e) =>
                                        //     handleSearch(
                                        //         e.target.value,
                                        //         "name"
                                        //     )
                                        // }
                                        />
                                    </label>
                                </div>

                            </div>
                        )}
                        locale={locale}
                        columns={columns}
                        className="bets-history-table"
                        bordered
                        dataSource={paginatedData}
                        pagination={false}
                        scroll={{ x: "max-content" }}
                        rowKey={(record) =>
                            record?._id ||
                            `${record?.match_id}-${record?.selection_id}`
                        }
                    />

                    <div className="bets-pagination-row">

                        <div className="bets-entry-info">
                            Showing{" "}
                            {filteredData?.length > 0
                                ? startIndex + 1
                                : 0}{" "}
                            to{" "}
                            {Math.min(
                                endIndex,
                                filteredData?.length || 0
                            )}{" "}
                            of {filteredData?.length || 0} entries
                        </div>

                        <div className="bets-pagination-controls">

                            <button
                                type="button"
                                className="bets-pagination-button"
                                onClick={handleFirst}
                                disabled={current === 1}
                            >
                                First
                            </button>

                            <Pagination
                                current={current}
                                pageSize={pageSize}
                                total={filteredData?.length || 0}
                                onChange={(page) =>
                                    setCurrent(page)
                                }
                                className="bets-pagination"
                                itemRender={(
                                    page,
                                    type,
                                    originalElement
                                ) => {
                                    if (type === "prev") {
                                        return (
                                            <span className="bets-page-link">
                                                Previous
                                            </span>
                                        );
                                    }

                                    if (type === "page") {
                                        return null;
                                    }

                                    if (type === "next") {
                                        return (
                                            <span className="bets-page-link">
                                                Next
                                            </span>
                                        );
                                    }

                                    return originalElement;
                                }}
                                showSizeChanger={false}
                            />

                            <button
                                type="button"
                                className="bets-pagination-button"
                                onClick={handleLast}
                                disabled={
                                    current >=
                                    Math.ceil(
                                        (filteredData?.length || 0) /
                                        pageSize
                                    )
                                }
                            >
                                Last
                            </button>

                        </div>
                    </div>

                </div>
            </section>

        </div>
    );
}


export default BetsList;
